import axios from 'axios';

const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || '/api';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120_000, // 2 Minuten – Zyklus kann lange dauern (E-Mail + KI)
  headers: { 'Content-Type': 'application/json' },
});

// --- Token-Cache: Vermeidet JSON.parse bei jedem Request ---
let _cachedToken: string | null = null;

/** Wird vom auth-store aufgerufen wenn sich der Token ändert. */
export function setAuthToken(token: string | null) {
  _cachedToken = token;
}

// Initialen Token aus localStorage laden (einmalig)
if (typeof window !== 'undefined') {
  try {
    const raw = localStorage.getItem('auth-storage');
    if (raw) {
      const parsed = JSON.parse(raw);
      _cachedToken = parsed?.state?.token ?? null;
    }
  } catch {
    // ignorieren
  }
}

// --- Interceptor: Bearer-Token automatisch mitsenden ---
apiClient.interceptors.request.use((config) => {
  if (_cachedToken) {
    config.headers.Authorization = `Bearer ${_cachedToken}`;
  }
  return config;
});

// --- Interceptor: 401 → automatischer Logout, erzwungene Passwort-Aenderung
// (Admin-Reset waehrend laufender Session) → Weiterleitung ---
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && typeof window !== 'undefined') {
      const url = error.config?.url || '';
      if (!url.includes('/auth/login')) {
        _cachedToken = null;
        localStorage.removeItem('auth-storage');
        window.location.href = '/login';
      }
    }
    // Admin hat das Passwort waehrend einer laufenden Session zurueckgesetzt
    // (agent/auth/dependencies.py::aktueller_benutzer erzwingt dies serverseitig
    // bei jedem Request) - der clientseitige, in localStorage persistierte Stand
    // ist dann veraltet. Direktes Patchen VOR dem harten Reload verhindert eine
    // Redirect-Schleife: AuthGuard wuerde mit dem veralteten (false-)Flag sonst
    // sofort wieder von /passwort-festlegen wegleiten.
    if (
      error.response?.status === 403 &&
      error.response?.data?.detail === 'PASSWORT_AENDERN_ERFORDERLICH' &&
      typeof window !== 'undefined' &&
      window.location.pathname !== '/passwort-festlegen'
    ) {
      try {
        const raw = localStorage.getItem('auth-storage');
        if (raw) {
          const parsed = JSON.parse(raw);
          if (parsed?.state?.benutzer) {
            parsed.state.benutzer.muss_passwort_aendern = true;
            localStorage.setItem('auth-storage', JSON.stringify(parsed));
          }
        }
      } catch {
        // ignorieren – AuthGuard/useStatus holen den Stand notfalls ueber /auth/me nach
      }
      window.location.href = '/passwort-festlegen';
    }
    return Promise.reject(error);
  },
);
